"use strict"

import React from "react"

import { cross_hair_layer } from "../../../../../components/shared_components_registration"

export const ColorBoxWithLabel = ({ color, opacity, text }) => {
  return (
    <>
      {color || text ? (
        <div style={{ display: "inline-block" }}>
          {color && (
            <div
              style={{
                height: "15px",
                width: "15px",
                marginRight: "5px",
                display: "inline-block",
                opacity: opacity || 1.0,
                backgroundColor: color,
              }}
            />
          )}
          {text && <span>{text}</span>}
        </div>
      ) : (
        <span>-</span>
      )}
    </>
  )
}

export default function PointDataOverlay({
  spacing = 20,
  pointData,
  timeExtractor,
  annotationData,
  runEventData = [],
}) {
  const displayValue = (value) => {
    if (typeof value !== "number") {
      return "" + value
    }

    const figs = Math.floor(Math.log10(Math.abs(value)))
    if (figs < -8) {
      return "0.0"
    } else {
      return value.toFixed(Math.min(8, Math.max(2, 2 - figs)))
    }
  }
  return (
    <div style={{ paddingRight: "5px" }}>
      {/*----- Line chart details. -----*/}
      {/*----- Substituted variables must be wrapped uniquely to stop Google Translate breaking updates -----*/}
      {/*----- and the dummy IDs stop JSX from combining adjacent tags which confuses Translate further. -----*/}
      {/*----- See: https://guoyunhe.me/en/2019/06/02/fix-react-issues-with-google-translate/ -----*/}
      {pointData.map((p, idx) => (
        <div key={idx} className={"flex-r"}>
          <svg width={20} height={spacing}>
            <g transform={`translate(10, ${spacing / 2})`}>{p.marker}</g>
          </svg>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              {p.marker.props.label ?? p.label}
              {cross_hair_layer.label_supplement(p)}
            </div>
            <div style={{ fontStyle: "italic", fontSize: "80%" }}>
              {cross_hair_layer.time_info(timeExtractor, p)}
              {cross_hair_layer.data_info(p, displayValue)}
            </div>
          </div>
        </div>
      ))}
      {/*----- /Line chart details -----*/}
      {/*----- Annotation (Skynaught) label details -----*/}
      {annotationData && (
        <div style={{ marginTop: "15px", paddingLeft: "10px" }}>
          <span style={{ fontWeight: "600", marginRight: "10px" }}>
            {`${annotationData?.type_name} Label:`}
          </span>
          <ColorBoxWithLabel
            color={annotationData?.label_details?.color}
            opacity={1.0}
            text={annotationData?.label_details?.display_name}
          />
        </div>
      )}
      {/*----- /Annotation label details -----*/}
      {/*----- Run Event Label Details -----*/}
      {runEventData && runEventData.length > 0 && (
        <>
          {runEventData.map((e) => {
            return (
              <React.Fragment key={e.id}>
                <hr />
                <div style={{ marginTop: "15px", paddingLeft: "10px" }}>
                  <ColorBoxWithLabel color={e.color} opacity={e.opacity} text={e.label} />
                  <div style={{ marginLeft: "17px" }}>
                    {e.option_details && (
                      <div
                        style={{ fontStyle: "italic", fontSize: "80%" }}
                      >{`Option = ${e.option_details}`}</div>
                    )}
                    {[
                      ["Time Frame", e.range],
                      ["Details", e.details],
                      ["Created By", e.create_details],
                      ["Updated By", e.update_details],
                    ]
                      .filter((d) => d[1])
                      .map((d, i) => (
                        <div
                          key={`${e.label}${i}`}
                          style={{ fontStyle: "italic", fontSize: "80%" }}
                        >{`${d[0]} = ${d[1]}`}</div>
                      ))}
                  </div>
                </div>
              </React.Fragment>
            )
          })}
        </>
      )}
      {/*----- /Run Event Label Details -----*/}
    </div>
  )
}
